import React from "react";
import { IconButton, Paper, TextField } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import FavoriteStudy from "./favorite.studies";
import SearchTable from "./search.table";
import { debounce } from "lodash";
import styled from "styled-components";

const StudyPlanSearch = ({ classes }) => {
  const [search, setSearch] = React.useState("");
  const [filter, setFilter] = React.useState("");

  const debouncedSearch = React.useCallback(
    debounce((search) => {
      setFilter(search);
    }, 1000),
    [],
  );

  return (
    <Container>
      <nav>
        <Paper style={{ height: "calc(100vh - 89px)" }}>
          <PaperContent>
            <FavoriteStudy/>
          </PaperContent>
        </Paper>
      </nav>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1em",
          overflow: "hidden",
        }}
      >
        <div
          style={{ position: "relative", width: "100%", paddingTop: "0.1em" }}
        >
          <TextField
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              debouncedSearch(e.target.value);
            }}
            style={{ width: "100%", borderRadius: "2rem !important" }}
            variant="outlined"
            placeholder="Search..."
            helperText="Search Study List... You can search by PCN, Sponsor Name, Indication"
          />
          {search && (
            <IconButton
              onClick={() => {
                setSearch("");
                debouncedSearch("");
              }}
              style={{
                position: "absolute",
                right: "40px",
                top: "15px",
                color: "white",
                padding: "2px",
              }}
              aria-label="clear"
            >
              <CloseIcon
                fontSize=".5rem"
                style={{ color: "gray" }}
              />
            </IconButton>
          )}
          <IconButton
            type="submit"
            style={{
              position: "absolute",
              right: "0",
              top: "5px",
              color: "white",
            }}
            aria-label="search"
          >
            <SearchIcon style={{ color: "var(--teal-600)" }} />
          </IconButton>
        </div>
        <div style={{ width: "100%" }}>
          <SearchTable filter={filter} />
        </div>
      </div>
    </Container>
  );
};

// Styled component for Paper content
const PaperContent = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  height: 100%;
  overflow: hidden;
`;

// Styled component for container
const Container = styled.div`
  padding-inline: 1em;
  padding-top: 1em;
  overflow-y: hidden;
  display: grid;
  grid-gap: 1em;
  grid-template-columns: 350px 1fr;
  width: 100%;
`;

export default StudyPlanSearch;
